import {OptionType} from 'platform/components';

import {isNotNil} from 'ramda';

import {MazdaWarrantyCode} from '@dms/api/workshop';

import {Nullish} from 'shared/web';

type MazdaCatalogEntry = MazdaWarrantyCode & {code: string};

type MazdaCatalogLabelFormatter = (entry: MazdaCatalogEntry) => string;

const hasCode = (entry: MazdaWarrantyCode): entry is MazdaCatalogEntry => isNotNil(entry.code);

const getDescriptionLabel: MazdaCatalogLabelFormatter = ({code, description}) =>
  description ?? code;

export function getMazdaCatalogOptions(
  entries: MazdaWarrantyCode[] | Nullish,
  getLabel: MazdaCatalogLabelFormatter = getDescriptionLabel
): OptionType[] {
  return (entries ?? []).filter(hasCode).map((entry) => ({
    value: entry.code,
    label: getLabel(entry),
  }));
}
